import { Redirect, Route, RouteProps, useLocation } from "react-router-dom";

import { UserRole } from "types/user";
import useAuth from "./useAuth";

// A custom hook that builds on useLocation to parse a query string
export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export const AuthenticatedRoute = (props: RouteProps) => {
  const { user } = useAuth();
  if (!user) return <Redirect to="/login" />;

  return <Route {...props} />;
};

export const UnauthenticatedRoute = (props: RouteProps) => {
  const { user } = useAuth();
  if (user) return <Redirect to="/" />;

  return <Route {...props} />;
};

export const PermittedRoute = (
  props: RouteProps & { permissions: UserRole[] }
) => {
  const { hasPermission } = useAuth();
  const { permissions, ...otherProps } = props;

  if (!hasPermission(permissions)) {
    return <Redirect to="/" />;
  }

  return <Route {...otherProps} />;
};
